import { Search, ShoppingCartOutlined } from "@mui/icons-material";
import styled from "styled-components";
import Badge from "@mui/material/Badge";
import { mobile } from "../responsive";
import { useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import { useEffect, useState } from "react";
import jwt_decode from "jwt-decode";
import Announcements from "./Announcements";

const Container = styled.div`
  top: 0rem;
  left: 0rem;
  position: sticky;
  z-index: 9999;
  background-color: #fff;
  border-bottom: solid 0.5px lightgrey;
  ${mobile({ position: "relative" })};
`;

const Wrapper = styled.div`
  padding: 10px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.3em !important;
  ${mobile({ padding: "1 1%", flexDirection: "column" })}
`;

const Left = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
`;

const SearchContainer = styled.form`
  border: solid 2px #212121;
  border-radius: 99px;
  width: 100%;
  &:hover {
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3), 0 2px 6px 2px rgba(0, 0, 0, 0.15);
    border: solid 2px #edf1fc;
  }

  &:focus-within {
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3), 0 2px 6px 2px rgba(0, 0, 0, 0.15);
    border: solid 2px #edf1fc;
  }

  ${mobile({ margin: "0.5em 0em" })};
`;

const SearchItem = styled.div`
  display: flex;
  align-items: center;
  padding: 0.5em;
  cursor: pointer;
  ${mobile({})};
`;

const Input = styled.input`
  border: none;
  font-size: 16px;
  padding: 0.1em 0 0.1em 0.8em;
  height: 30px;
  width: 60%;
  &:last-of-type {
    border-left: solid 0.5px lightgrey;
    width: 30%;
  }
  ,
  &:focus {
    outline: none;
  }
  &::-webkit-search-cancel-button {
    display: none;
    -webkit-appearance: none;
  }
  -webkit-appearance: none;
  background-color: #fff;

  ${mobile({ fontSize: "14px" })};
`;

const Center = styled.div`
  flex: 1;
  ${mobile({ margin: "0 0.4em" })};
`;

const Logo = styled.p`
  font-weight: bold;
  font-size: 40px;
  font-family: Bebas Neue;
  text-align: center;
  color: #4339fa !important;
  padding-left: 1em;

  ${mobile({ fontSize: "24px" })}
`;
const LogoLink = styled(Link)`
  text-decoration: none !important;
  color: #000 !important;
  ${mobile({ fontSize: "24px" })}
`;

const Right = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 1em;
  colour: #000;

  a {
    text-decoration: none;
    color: #000;
    &:visited {
      color: #000;
    }
  }

  ${mobile({ flex: 2, justifyContent: "center", marginTop: "0.5em" })};
`;

const MenuItem = styled.div`
  font-size: 14px;
  cursor: pointer;
  margin-left: 25px;

  display: inline-block;
  span {
    font-weight: bold;
    color: #4339fa;
  }

  ${mobile({ fontSize: "12px", marginLeft: "10px" })}
`;

const Navbar = () => {
  const quantity = useSelector((state) => state.cart.quantity);

  const [searchText, setSearchText] = useState("");
  const [location, setLocation] = useState("");
  const history = useHistory();
  const [display, setDisplay] = useState("");

  useEffect(() => {
    setDisplay(window.location.pathname.includes("Cart") ? "none" : "");
  }, []);

  const handleKeyPress = (e) => {
    const isTouchDevice = "ontouchstart" in window || navigator.maxTouchPoints;

    // Prevent default behavior of Enter key only if it's a touch device
    if (isTouchDevice && e.key === "Enter") {
      e.preventDefault();
    }
    if (e.key === "Enter" && searchText !== "") {
      let newLocation = null;
      if (location) {
        newLocation = location.location.replace(/ /g, "").toUpperCase();
      }

      const searchQuery =
        "/Search/" + searchText.search + (newLocation ? "/" + newLocation : "");
      history.push(searchQuery);
    }
  };

  const handlePostcodeKeyPress = (e) => {
    const isTouchDevice = "ontouchstart" in window || navigator.maxTouchPoints;

    // Prevent default behavior of Enter key only if it's a touch device
    if (isTouchDevice && e.key === "Enter") {
      e.preventDefault();
    }
    if (e.key === "Enter" && searchText) {
      let newLocation = null;
      if (location) {
        newLocation = location.location.replace(/ /g, "").toUpperCase();
      }
      const searchQuery =
        "/Search/" + searchText.search + (newLocation ? "/" + newLocation : "");
      history.push(searchQuery);
    }
  };
  const clickSearch = (e) => {
    if (searchText !== "") {
      let newLocation = null;
      if (location) {
        newLocation = location.location.replace(/ /g, "").toUpperCase();
      }

      const searchQuery =
        "/Search/" + searchText.search + (newLocation ? "/" + newLocation : "");
      history.push(searchQuery);
    }
  };

  const handleChange = (event) => {
    setSearchText({ [event.target.name]: event.target.value });
  };

  const handleLocation = (event) => {
    setLocation({ [event.target.name]: event.target.value });
  };

  var tokenNotExpired = null;
  var accessPermitted = null;
  const user = useSelector((state) => state.user.currentUser);
  if (user?.accessToken) {
    var decoded = jwt_decode(user.accessToken);
    const tokenDate = new Date(decoded.exp * 1000);
    tokenNotExpired = !(new Date() - tokenDate > 0);
    accessPermitted = user && tokenNotExpired;
  } else {
    accessPermitted = false;
  }
  return (
    <>
      <Container style={{ display: display }}>
        <Wrapper>
          <Left>
            <LogoLink to={`/`}>
              <Logo>
                RENTOODLE
                <sup style={{ fontSize: "0.4em", marginLeft: "0.4em" }}>®</sup>
              </Logo>
            </LogoLink>
          </Left>
          <Center>
            <SearchContainer>
              <SearchItem>
                <Input
                  type="search"
                  name="search"
                  placeholder="Search rentals..."
                  onKeyDown={handleKeyPress}
                  onChange={handleChange}
                  autocomplete="off"
                />

                <Input
                  type="text"
                  name="location"
                  placeholder="Postcode"
                  onKeyDown={handlePostcodeKeyPress}
                  onChange={handleLocation}
                  tabindex="-1"
                  autocomplete="off"
                />
                <Search style={{ color: "#aaa" }} onClick={clickSearch} />
                <button
                  type="submit"
                  style={{ display: "none" }}
                  onSubmit={handleKeyPress}
                ></button>
              </SearchItem>
            </SearchContainer>
          </Center>

          <Right>
            {accessPermitted ? (
              <>
                <Link to={`/faqs`}>
                  <MenuItem>
                    <span>FAQs</span>
                  </MenuItem>
                </Link>

                <Link to={`/profile/${user._id}`}>
                  <MenuItem>My Account</MenuItem>
                </Link>
              </>
            ) : (
              <div>
                <Link to={`/faqs`}>
                  <MenuItem>
                    <span>FAQs</span>
                  </MenuItem>
                </Link>
                <Link to={`/Login`}>
                  <MenuItem>Sign In</MenuItem>
                </Link>
                <Link to={`/Register`}>
                  <MenuItem>Register</MenuItem>
                </Link>
              </div>
            )}

            <Link to="/Cart">
              <MenuItem>
                <Badge
                  badgeContent={quantity}
                  color="primary"
                  sx={{
                    "& .MuiBadge-badge": {
                      backgroundColor: "#4339fa",
                      color: "#FFF",
                      fontWeight: "bold",
                    },
                  }}
                >
                  <ShoppingCartOutlined />
                </Badge>
              </MenuItem>
            </Link>
          </Right>
        </Wrapper>
      </Container>
      <Announcements />
    </>
  );
};

export default Navbar;
